import Tasks from './Tasks.view';

export default Tasks;
